__turbopack_context__.v({
  "card": "hairShadeShortlist-module___D2teq__card",
  "copy": "hairShadeShortlist-module___D2teq__copy",
  "footer": "hairShadeShortlist-module___D2teq__footer",
  "grid": "hairShadeShortlist-module___D2teq__grid",
  "shortlist": "hairShadeShortlist-module___D2teq__shortlist",
  "swatch": "hairShadeShortlist-module___D2teq__swatch",
});
